<div class="detail" [ngClass]="{'p-0' : isSidePanel}">
  <div class="detail_tabs">
    <app-horizontal-tabs (actionEvent)="tabClicked($event)" [tabs]="[
      'Dashboard',
      'Price Info',
      'Offers',
      'Activity',
    ]" [activeTab]="activeTab"></app-horizontal-tabs>
  </div>
  <div class="detail_content">
    <ng-container>
      <div *ngIf="activeTab === 'Dashboard'">
        <app-dashboard-priceyard-panel [sku]="selectedSku" [id]="'sidebar'"></app-dashboard-priceyard-panel>
      </div>

      <div *ngIf="activeTab === 'Price Info'" class="h-100">
        <app-sku-price-range-grid (editEmitter)="togglePriceEdit()"  [sku]="selectedSku" [selectedRow]="selectedSku" [selectedMarkupType]="selectedMarkupType"></app-sku-price-range-grid>
      </div>

      <div *ngIf="activeTab === 'Offers'" class="h-100">
        <app-sku-competition-grid [sku]="selectedSku"></app-sku-competition-grid>
      </div>

      <div *ngIf="activeTab === 'Activity'" class="h-100">
        <app-sku-history-grid [sku]="selectedSku"></app-sku-history-grid>
      </div>
    </ng-container>
  </div>

</div>
